// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.post-form {
    box-sizing: border-box;
    background-color: white;
    margin: 0 auto;
    width: 100%;
}

.post-form .text-area-with-mentions textarea {
    width: 100%;
    height: 150px;
    box-sizing: border-box;
    border:none;
    resize: none;
    padding: 10px;
    border-radius: 7px;
}
.post-form .text-area-with-mentions textarea:focus {
    outline: none !important;
}
.post-form .error {
    padding: 5px;
    color: var(--danger-color-main);
}
.post-form .post-form__controls .attachment-controls .post-form__image,
.post-form .post-form__controls .attachment-controls .post-form__link {
    display: inline-block;
}
.post-form .attachments .attachment {
    padding: 5px 0;
    text-align: center;
}
.post-form .attachments .attachment .attached {
    display: inline-block;
}
.post-form .attachments .link-preview {
    position: relative;
}
.post-form .attachments .link-preview .remove {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
}
.post-form .attachments .link-preview .remove svg {
    width: 24px;
    height: 24px;
    opacity: 0.75;
    color: var(--primary-color-lightest);
    filter: drop-shadow(0 0 0 rgba(0 0 0 / 0.75))
}

.post-form .post-form__controls {
    display: grid;
    grid-template-columns: auto auto;
    padding: 5px;
}
.post-form .post-form__controls .post-form__controls__visibility {
    text-align: right;
}
.post-form .buttons {
    text-align: right;
    align-self: end;
}

@media (width >= 700px) {
    .post-form {
        border: thin solid var(--main-border-color);
        width: 650px;
        padding: 7px;
        border-radius: 7px;
        box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);
    }
}
@media (width < 700px) {
    .post-form {
        border-top: thin solid var(--main-border-color);
        border-bottom: thin solid var(--main-border-color);
        box-sizing: border-box;
        width: 100%;
        margin: 0 auto;
        padding: 7px 0;
        box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);
    }
    .post-form textarea {
        width: 100%;
        height: 200px;
        box-sizing: border-box;
        resize: none;
        padding: 10px;
        border: none;
        /*border-radius: 0;
        border-left: none;
        border-right: none;*/
    }
    .post-form textarea:focus {
        border-radius: none;
    }
    .attachment-button-text {
        display: none;
    }
}
`, "",{"version":3,"sources":["webpack://./client/components/posts/PostForm/PostForm.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,wBAAwB;AAC5B;AACA;IACI,YAAY;IACZ,+BAA+B;AACnC;AACA;;IAEI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,aAAa;AACjB;AACA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC;AACJ;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI;QACI,2CAA2C;QAC3C,YAAY;QACZ,YAAY;QACZ,kBAAkB;QAClB,6CAA6C;IACjD;AACJ;AACA;IACI;QACI,+CAA+C;QAC/C,kDAAkD;QAClD,sBAAsB;QACtB,WAAW;QACX,cAAc;QACd,cAAc;QACd,6CAA6C;IACjD;IACA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,YAAY;QACZ,aAAa;QACb,YAAY;QACZ;;4BAEoB;IACxB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,aAAa;IACjB;AACJ","sourcesContent":[".post-form {\n    box-sizing: border-box;\n    background-color: white;\n    margin: 0 auto;\n    width: 100%;\n}\n\n.post-form .text-area-with-mentions textarea {\n    width: 100%;\n    height: 150px;\n    box-sizing: border-box;\n    border:none;\n    resize: none;\n    padding: 10px;\n    border-radius: 7px;\n}\n.post-form .text-area-with-mentions textarea:focus {\n    outline: none !important;\n}\n.post-form .error {\n    padding: 5px;\n    color: var(--danger-color-main);\n}\n.post-form .post-form__controls .attachment-controls .post-form__image,\n.post-form .post-form__controls .attachment-controls .post-form__link {\n    display: inline-block;\n}\n.post-form .attachments .attachment {\n    padding: 5px 0;\n    text-align: center;\n}\n.post-form .attachments .attachment .attached {\n    display: inline-block;\n}\n.post-form .attachments .link-preview {\n    position: relative;\n}\n.post-form .attachments .link-preview .remove {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    z-index: 1000;\n}\n.post-form .attachments .link-preview .remove svg {\n    width: 24px;\n    height: 24px;\n    opacity: 0.75;\n    color: var(--primary-color-lightest);\n    filter: drop-shadow(0 0 0 rgba(0 0 0 / 0.75))\n}\n\n.post-form .post-form__controls {\n    display: grid;\n    grid-template-columns: auto auto;\n    padding: 5px;\n}\n.post-form .post-form__controls .post-form__controls__visibility {\n    text-align: right;\n}\n.post-form .buttons {\n    text-align: right;\n    align-self: end;\n}\n\n@media (width >= 700px) {\n    .post-form {\n        border: thin solid var(--main-border-color);\n        width: 650px;\n        padding: 7px;\n        border-radius: 7px;\n        box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);\n    }\n}\n@media (width < 700px) {\n    .post-form {\n        border-top: thin solid var(--main-border-color);\n        border-bottom: thin solid var(--main-border-color);\n        box-sizing: border-box;\n        width: 100%;\n        margin: 0 auto;\n        padding: 7px 0;\n        box-shadow: 0px 0px 5px -3px rgba(0,0,0,0.25);\n    }\n    .post-form textarea {\n        width: 100%;\n        height: 200px;\n        box-sizing: border-box;\n        resize: none;\n        padding: 10px;\n        border: none;\n        /*border-radius: 0;\n        border-left: none;\n        border-right: none;*/\n    }\n    .post-form textarea:focus {\n        border-radius: none;\n    }\n    .attachment-button-text {\n        display: none;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
